import PropTypes from 'prop-types';
import { Button, Space } from 'antd';
import FeatherIcon from 'feather-icons-react';
import styles from './styles/AdvancedTable.module.css';

const TableBulkActions = ({ selectedRows = [], actions = [], onClearSelection }) => {
  if (selectedRows.length === 0) return null;

  return (
    <div className={styles.bulkActionsBar}>
      <div className={styles.selectedCount}>
        <FeatherIcon icon="check-square" size={16} style={{ marginRight: 8 }} />
        {selectedRows.length} row{selectedRows.length > 1 ? 's' : ''} selected
      </div>

      <div className={styles.actions}>
        <Space>
          {actions.map((action, index) => (
            <Button
              key={index}
              type={action.type || 'default'}
              danger={action.danger}
              icon={action.icon ? <FeatherIcon icon={action.icon} size={14} /> : null}
              onClick={() => action.onClick(selectedRows)}
              disabled={action.disabled}
            >
              {action.label}
            </Button>
          ))}
          <Button onClick={onClearSelection}>Clear Selection</Button>
        </Space>
      </div>
    </div>
  );
};

TableBulkActions.propTypes = {
  selectedRows: PropTypes.array,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.string,
      type: PropTypes.string,
      danger: PropTypes.bool,
      disabled: PropTypes.bool,
      permission: PropTypes.string,
    })
  ),
  onClearSelection: PropTypes.func.isRequired,
};

export default TableBulkActions;
